import React from 'react'
import { ItemProps, Navigation } from '../../navigation/block'
import { defineBlock, useBlockEffect } from '@smartfire/js-block-engine'
import { useCompetitionProps } from '../../hooks/useCompetitionProps'
import { retrieveExtId } from '../types'
import { useLastViewedCompetitions } from '../../hooks/competitions'

interface PouleTopMenuProps {
    nav: ItemProps[]
}

const PouleTopMenu = (attributes) => {
    const {
        attributes: { nav },
        params: { url_competition },
    } = useCompetitionProps<PouleTopMenuProps>({
        initDataFromPhpFirstRendering: attributes,
    })

    const { addLastViewed } = useLastViewedCompetitions()

    useBlockEffect(() => {
        addLastViewed(retrieveExtId(url_competition))
    }, [addLastViewed, url_competition])

    return <Navigation nav={nav} />
}

export default defineBlock({
    Block: PouleTopMenu,
})
